import { LeftArrowSvg, RightArrowSvg } from '../../icons';
import React, { useState, useEffect } from 'react';
import { CancelButtonWrapper, Container, DayText, MonthText, WeekText } from './components';

const { datesGenerator } = require('dates-generator');

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']

export const Calendar = (props) => {

  const { selectedDate, onChangeDate, hasCancel, disableAfter, disableBefore, selectedPeriod } = props;

  const [dates, setDates] = useState([]);
  const [calendar, setCalendar] = useState({
    month: selectedDate ? selectedDate.getMonth() : props.nextMonth ? new Date().getMonth() + 1 : new Date().getMonth(),
    year: selectedDate ? selectedDate.getFullYear() : new Date().getFullYear(),
  });

  useEffect(() => {
    const body = {
      month: calendar.month,
      year: calendar.year,
      startingDay: 1
    };
    const { dates, nextMonth, nextYear, previousMonth, previousYear } = datesGenerator(body);

    setDates([...dates]);
    setCalendar({
      ...calendar,
      nextMonth,
      nextYear,
      previousMonth,
      previousYear
    });
  }, [])

  const onClickNext = (changeYear) => {
    const body = {
      month: changeYear ? calendar.month : calendar.nextMonth,
      year: changeYear ? calendar.year + 1 : calendar.nextYear
    };
    const { dates, nextMonth, nextYear, previousMonth, previousYear } = datesGenerator(body);

    setDates([...dates]);
    setCalendar({
      ...calendar,
      month: changeYear ? calendar.month : calendar.nextMonth,
      year: changeYear ? calendar.year + 1 : calendar.nextYear,
      nextMonth,
      nextYear,
      previousMonth,
      previousYear
    });
  }

  const onClickPrevious = (changeYear) => {
    const body = {
      month: changeYear ? calendar.month : calendar.previousMonth,
      year: changeYear ? calendar.year - 1 : calendar.previousYear
    };
    const { dates, nextMonth, nextYear, previousMonth, previousYear } = datesGenerator(body);

    setDates([...dates]);
    setCalendar({
      ...calendar,
      month: changeYear ? calendar.month : calendar.previousMonth,
      year: changeYear ? calendar.year - 1 : calendar.previousYear,
      nextMonth,
      nextYear,
      previousMonth,
      previousYear
    });
  }

  const onSelectDate = (date) => {
    onChangeDate(new Date(date.year, date.month, date.date))
  }

  return (
    <Container>
      <div className="flex items-center justify-between px-2">
        <div className="flex items-center">
          <MonthText className="mr-2">
            {months[calendar.month || 0]}
          </MonthText>
          <MonthText>
            {calendar.year}
          </MonthText>
        </div>
        <div className="flex items-center">
          <div className="flex items-center mr-2.5">
            <div className="mr-1">
              <LeftArrowSvg double onClick={() => onClickPrevious(true)} />
            </div>
            <LeftArrowSvg onClick={() => onClickPrevious(false)} />
          </div>
          <div className="flex items-center">
            <div className="mr-1">
              <RightArrowSvg onClick={() => onClickNext(false)} />
            </div>
            <RightArrowSvg double onClick={() => onClickNext(true)} />
          </div>
        </div>
      </div>
      <table className="w-full mt-6">
        <tbody>
          <tr>
            {days.map((day) => (
              <td key={day}>
                <WeekText>
                  {day}
                </WeekText>
              </td>
            ))}
          </tr>
          {dates.length > 0 && dates.map((week) => (
            <tr key={JSON.stringify(week[0])}>
              {week.map((each) => {
                const eachDate = new Date(each.year, each.month, each.date);
                const disabled = (!!disableAfter && (eachDate > disableAfter)) || (!!disableBefore && (eachDate < disableBefore));
                const selected = each.date === selectedDate?.getDate() && each.month === selectedDate.getMonth() && each.year === selectedDate.getFullYear();
                const inSelectedPeriod = (selectedPeriod?.start || selectedPeriod?.end) && (selectedPeriod?.start ? eachDate > selectedPeriod.start : true) && (selectedPeriod?.end ? eachDate < selectedPeriod.end : true);
                return (
                  <td key={JSON.stringify(each)}>
                    {each.month === calendar.month &&
                      <DayText
                        onClick={() => disabled ? () => { } : onSelectDate(each)}
                        selected={selected}
                        disabled={disabled}
                        inSelectedPeriod={inSelectedPeriod}
                      >
                        {each.date}
                      </DayText>
                    }
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {hasCancel && selectedDate &&
        <div className="flex items-center justify-end mt-3 w-full">
          <svg className="cursor-pointer" width="44" height="28" viewBox="0 0 44 28" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { onChangeDate(undefined) }}>
            <CancelButtonWrapper d="M0 14C0 6.26801 6.26801 0 14 0H30C37.732 0 44 6.26801 44 14V14C44 21.732 37.732 28 30 28H14C6.26801 28 0 21.732 0 14V14Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M26.1436 10.6215C26.3381 10.6215 26.5 10.783 26.5 10.9885V11.1785C26.5 11.379 26.3381 11.5455 26.1436 11.5455H17.8569C17.6619 11.5455 17.5 11.379 17.5 11.1785V10.9885C17.5 10.783 17.6619 10.6215 17.8569 10.6215H19.3148C19.6109 10.6215 19.8687 10.411 19.9353 10.114L20.0116 9.77299C20.1303 9.3085 20.5207 9 20.9676 9H23.0324C23.4744 9 23.8692 9.3085 23.9835 9.74849L24.0652 10.1135C24.1313 10.411 24.3891 10.6215 24.6857 10.6215H26.1436ZM25.4029 17.567C25.5551 16.1485 25.8216 12.7786 25.8216 12.7446C25.8313 12.6416 25.7978 12.5441 25.7312 12.4656C25.6597 12.3921 25.5692 12.3486 25.4695 12.3486H18.5343C18.4341 12.3486 18.3388 12.3921 18.2727 12.4656C18.2055 12.5441 18.1725 12.6416 18.1773 12.7446C18.1782 12.7508 18.1878 12.8695 18.2038 13.068C18.2748 13.9496 18.4726 16.4051 18.6004 17.567C18.6908 18.423 19.2525 18.961 20.066 18.9805C20.6938 18.995 21.3406 19 22.0019 19C22.6248 19 23.2575 18.995 23.9047 18.9805C24.7464 18.966 25.3076 18.4375 25.4029 17.567Z" fill="white" />
          </svg>
        </div>
      }
    </Container>
  );
}
